export const ItemWikiCsv = (dataSource) => {
    return {
    fileName: "Wiki item list",
    headers: [
    {
        label: 'Item id',
        key: 'itemId', 
    },
    {
        label: 'Name',
        key: 'name', 
    },
    {
        label: 'IsHerb',
        key: 'isHerb', 
    },
    {
        label: 'IsPotion',
        key: 'isPotion', 
    },
    {
        label: 'Tool',
        key: 'tool', 
    },
    {
        label: 'Description',
        key: 'description', 
    }    
    ], 
    data: dataSource.map(_ =>  
        {
    const description = JSON.parse(_.description);
    const isHerb = _.isHerb === true ? true : null;
    const isPotion = _.isPotion === true ? true : null;

    return {
      itemId: _.id,
      name: _.name,
      description: description && description?.ops[0].insert,
      isHerb: isHerb,
      isPotion: isPotion,
      tool: _.tool?.name
    }})
  }
}

export const ItemSlCsv = (dataSource) => {
    return {
    fileName: "SL item list",
    headers: [
    {
        label: 'Item id',
        key: 'itemId', 
    },
    {
        label: 'Name',
        key: 'name', 
    },
    {
        label: 'IsHerb',
        key: 'isHerb', 
    },
    {
        label: 'IsPotion',
        key: 'isPotion', 
    },
    {
        label: 'Tool',
        key: 'tool', 
    },
    {
        label: 'Value',
        key: 'value', 
    },
    {
        label: 'Resources value',
        key: 'resourceValues', 
    },
    {
        label: "Steps to craft",
        key: "stepsToCraft"
    },
    {
        label: 'IsKnown',
        key: 'isKnown', 
    },
    {
        label: 'Description',
        key: 'description', 
    }      
    ], 
    data: dataSource.map(_ =>  
        {
    const description = JSON.parse(_.description);
    const isHerb = _.isHerb === true ? true : null;
    const isPotion = _.isPotion === true ? true : null;
    const isKnown = _.isKnown === true ? true : null;
    return {
      itemId: _.id,
      name: _.name,
      description: description && description?.ops[0].insert,
      isHerb: isHerb,
      isPotion: isPotion,
      tool: _.tool?.name,
      value: _.baseValue ?? _.calculatedValue,
      isKnown: isKnown,
      resourceValues: _.calculatedBaseValues,
      stepsToCraft: _.amountTimesCrafted
    }})
  }
}

export const ItemRecipeWikiCsv = (dataSource, allItems) => {
    return {
    fileName: "Wiki item-recipe list",
    headers: [
    {
        label: 'Item id',
        key: 'itemId', 
    },
    {
        label: 'Name',
        key: 'name', 
    },
    {
        label: 'Tool',
        key: 'tool', 
    },
    {
        label: 'Tool level',
        key: 'toolLevel', 
    },
    {
        label: 'Amount crafted',
        key: 'amountCrafted', 
    },
    {
        label: 'Items needed',
        key: 'itemsNeeded', 
    }              
    ], 
    data: dataSource.map(_ =>  
        {

            const itemsNeeded = []
            if(_.itemsNeeded !== undefined) {
                _.itemsNeeded.forEach(itemNeed => {
                    const foundItem = allItems.find(_ => _.id === itemNeed.itemId)
                    itemsNeeded.push(`${itemNeed.amount}x [${foundItem?.id}] ${foundItem?.name}`)
                }) 
            }
    // const description = JSON.parse(_.description);
    // const isHerb = _.isHerb === true ? true : null;
    // const isPotion = _.isPotion === true ? true : null;

    return {
      itemId: _.item?.id,
      name: _.item?.name,
      tool: _.item?.tool?.name,
      toolLevel: _.toolLevel,
      amountCrafted: _.amountCrafted,
      itemsNeeded: itemsNeeded
    }})
  }
}


